enum JobContactNotInterestedReason {
	Undefined           = 0,
	NotEnoughExperience = 1,

}

export default JobContactNotInterestedReason;